export default __webpack_public_path__ + "static/media/Tutolast-min.a1cf33b2.jpg";